"use strict";
import Auth from "../util/auth";
export const isFactorAccount = () => {
  return Auth.getCurrentUser().account.factor_account;
};
